export default "__VITE_ASSET__DLNCYq66__"